module.exports = __webpack_public_path__ + "img/icon-customer-card-green@3x.188da7de.png";